"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var threshold_1 = require("../features/threshold");
var historicalComparisonSubtitle_1 = require("./historicalComparisonSubtitle");
var noComparisonSubtitle_1 = require("./noComparisonSubtitle");
var targetSubtitle_1 = require("./targetSubtitle");
exports.createSubtitle = function (currentPoint, definition) {
    var _a;
    var line = threshold_1.getDefaultLineForThreshold(definition.features.threshold);
    if (!line) {
        return noComparisonSubtitle_1.noComparisonRowSubtitle()();
    }
    var style = threshold_1.getLineStyleForDefaultThresholdLine(definition);
    switch ((_a = style) === null || _a === void 0 ? void 0 : _a.deltaLabel) {
        case threshold_1.DeltaLabelStyle.HISTORICAL_DELTA:
            return historicalComparisonSubtitle_1.historicalComparisonRowSubtitle(definition)(currentPoint);
        case threshold_1.DeltaLabelStyle.TARGET_VALUE:
            return targetSubtitle_1.targetRowSubtitle(definition)(currentPoint);
        default:
            return undefined;
    }
};
//# sourceMappingURL=core.js.map